import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getGames } from "../../api/games.api";

const CreateGatherModal = ({
  open,
  eventId,
  handleClose,
  handleSubmit,
}) => {
  const [games, setGames] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    eventId: null,
    name: "",
    description: "",
    game: "",
    maxParticipants: 2,
    minParticipants: 1,
  });

  const initialFormData = useMemo(
    () => ({
      id: null,
      eventId: null,
      name: "",
      description: "",
      game: "",
      maxParticipants: 2,
      minParticipants: 1,
    }),
    []
  );

  useEffect(() => {
    getGames().then((response) => {
      setGames(response.data);
      setFormData(initialFormData);
    });
  }, [eventId, initialFormData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => {
      const updatedFormData = {
        ...prevState,
        [name]: type === "checkbox" ? checked : value,
      };
      return updatedFormData;
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (

      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <form onSubmit={onSubmit}>
            <Typography variant="h3">
              Create Gather
            </Typography>
            <div>
              <TextField
                id="name"
                label="Name"
                name="name"
                variant="outlined"
                fullWidth
                value={formData.name}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div>
              <TextField
                id="description"
                label="Description"
                name="description"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                value={formData.description}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div>
              <FormControl fullWidth>
                <InputLabel id="select-game-label">Game</InputLabel>
                <Select
                  labelId="select-game-label"
                  id="game"
                  name="game"
                  value={formData.game}
                  label="Game"
                  onChange={handleChange}
                >
                  {games.map((game) => (
                    <MenuItem key={game.id} value={game}>
                      {game.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div>
              <TextField
                id="participantCountMin"
                label="Min. Participants"
                name="minParticipants"
                variant="outlined"
                fullWidth
                value={formData.minParticipants}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div>
              <TextField
                id="participantCountMax"
                label="Max. Participants"
                name="maxParticipants"
                variant="outlined"
                fullWidth
                value={formData.maxParticipants}
                onChange={(e) => handleChange(e)}
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" onClick={onSubmit}>
           Create
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default CreateGatherModal;
